export default __webpack_public_path__ + "static/media/Formula.820af7e8.svg";